module.exports = __webpack_public_path__ + "static/flags/PM-b70b64a09926cca3a644443d2afa220c.gif";